import app from "./main.js";
import { createRouter, createWebHistory } from "vue-router";
import decodeToken from "./js/decodeToken.js";

import Login from "./views/login/Login.vue";
import AppTerms from "./views/AppTerms.vue";
import CreatePassword from "./views/login/CreatePassword.vue";
import ResetPassword from "./views/login/ResetPassword.vue";
import ResetAppPassword from "./views/login/ResetAppPassword.vue";
import ForgotPassword from "./views/login/ForgotPassword.vue";
import UnsubscribeNewsletter from "./views/newsletter/UnsubscribeNewsletter.vue";

import SubmenuPerfil from "./views/complementaryRegistration/SubmenuPerfil.vue";
import Perfil from "./views/complementaryRegistration/Perfil.vue";

import WhoWeAre from "./views/WhoWeAre.vue";
import Announcements from "./views/Announcements.vue";
import ChangePassword from "./views/login/ChangePassword.vue";

//Chamados Pendentes
import PatientTicketList from "./views/patientTicket/PatientTicketList.vue";

//Meus Pacientes
import PatientList from "./views/patients/PatientList.vue";
import MedicalRecord from "./views/patients/submenu/MedicalRecord.vue";
import HistoryRecords from "./views/patients/submenu/HistoryRecords.vue";
import Prescriptions from "./views/patients/submenu/Prescriptions.vue";
import ClinicalEvolution from "./views/patients/submenu/ClinicalEvolution.vue";
import Chat from "./views/patients/submenu/Chat.vue";
import ChatHistory from "./views/patients/submenu/ChatHistory.vue";
import AttachedDocuments from "./views/patients/submenu/AttachedDocuments.vue";
import Actions from "./views/patients/submenu/Actions.vue";
import Barriers from "./views/patients/submenu/Barriers.vue";
import VideoCallHistory from "./views/patients/submenu/VideoCallHistory.vue";
import PatientManagement from "./views/patients/submenu/PatientManagement.vue";
// POC Cuidados Paliativos: pedido de apoio à equipe matricial
import MatrixSupport from "./views/patients/submenu/MatrixSupport.vue";
import MatrixRequestDetail from "./views/patients/submenu/MatrixRequestDetail.vue";
import LilaCalendar from "./views/LilaCalendar.vue";

import Step1PatientInformation from "./views/patients/register/Step1PatientInformation.vue";
import Step2PatientInformation from "./views/patients/register/Step2PatientInformation.vue";
import Step3PatientInformation from "./views/patients/register/Step3PatientInformation.vue";
import Step4PatientInformation from "./views/patients/register/Step4PatientInformation.vue";

import AllActions from "./views/AllActions.vue";
import AutomaticMessages from "./views/management/AutomaticMessages.vue";
// import HistoryRecordTypes from "./views/management/HistoryRecordTypes.vue";
import Notifications from "./views/notifications/Notifications.vue";
import Journey from "./views/journey/Journey.vue";

import Reports from "./views/management/Reports.vue";
// POC Cuidados Paliativos (Tela 7): painel da equipe matricial
import PalliativeNetwork from "./views/management/PalliativeNetwork.vue";
import PalliativeTeamDetail from "./views/management/PalliativeTeamDetail.vue";
import SusProduction from "./views/management/SusProduction.vue";
import Professionals from "./views/management/Professionals.vue";
import AddProfessional from "./views/management/AddProfessional.vue";
import Units from "./views/management/Units.vue";
import AddUnit from "./views/management/AddUnit.vue";
import Licenses from "./views/management/Licenses.vue";
import BI from "./views/management/BI.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: "/", name: "login", component: Login },
    { path: "/termos_uso", name: "terms", component: AppTerms },
    { path: "/home", name: "home" },
    {
      path: "/criar_senha/:token?",
      name: "createPassword",
      component: CreatePassword
    },
    {
      path: "/resetar_senha/:token?",
      name: "resetPassword",
      component: ResetPassword
    },
    {
      path: "/resetar_senha_app/:token?",
      name: "resetAppPassword",
      component: ResetAppPassword
    },
    {
      path: "/esqueci_senha",
      name: "forgotPassword",
      component: ForgotPassword
    },
    {
      path: "/descadastro_newsletter",
      name: "unsubscribeNewsletter",
      component: UnsubscribeNewsletter,
      meta: { alwaysPublic: true }
    },

    {
      path: "/chamados_pendentes",
      name: "patientTickets",
      title: "Chamados",
      component: PatientTicketList,
      children: [
        {
          path: "ficha/:id",
          name: "patientMedicalRecord",
          component: MedicalRecord
        },
        {
          path: "registros/:id",
          name: "patientHistoryRecord",
          component: HistoryRecords
        },
        {
          path: "prescriptions/:id",
          name: "patientPrescriptions",
          component: Prescriptions
        },
        {
          path: "evolucao_clinica/:id",
          name: "patientClinicalEvolution",
          component: ClinicalEvolution
        },
        { path: "conversa/:id", name: "patientChat", component: Chat },
        {
          path: "solicitar_apoio/:id",
          name: "patientMatrixSupport",
          component: MatrixSupport,
          meta: { feature: 16 }
        },
        {
          path: "pedido_apoio/:id",
          name: "patientMatrixRequest",
          component: MatrixRequestDetail,
          meta: { feature: 16 }
        },
        { path: "barriers/:id", name: "patientBarriers", component: Barriers },
        { path: "actions/:id", name: "patientActions", component: Actions },
        {
          path: "conversas_encerradas/:id",
          name: "patientClosedMessages",
          component: ChatHistory
        },
        {
          path: "anexos/:id",
          name: "patientAttachments",
          component: AttachedDocuments
        },
        {
          path: "teleconsultas/:id",
          name: "patientTeleconsultas",
          component: VideoCallHistory
        },
        {
          path: "gestao/:id",
          name: "patientManagement",
          component: PatientManagement,
          meta: { minRole: 1 }
        }
      ]
    },
    {
      path: "/pacientes",
      exact: true,
      name: "myPatients",
      title: "Pacientes",
      component: PatientList,
      children: [
        {
          path: "ficha/:id",
          name: "myPatientMedicalRecord",
          component: MedicalRecord
        },
        {
          path: "registros/:id",
          name: "myPatientHistoryRecords",
          component: HistoryRecords
        },
        {
          path: "prescriptions/:id",
          name: "mypatientPrescriptions",
          component: Prescriptions
        },
        {
          path: "evolucao_clinica/:id",
          name: "myPatientClinicalEvolution",
          component: ClinicalEvolution
        },
        { path: "conversa/:id", name: "myPatientChat", component: Chat },
        {
          path: "solicitar_apoio/:id",
          name: "myPatientMatrixSupport",
          component: MatrixSupport,
          meta: { feature: 16 }
        },
        {
          path: "pedido_apoio/:id",
          name: "myPatientMatrixRequest",
          component: MatrixRequestDetail,
          meta: { feature: 16 }
        },
        {
          path: "barriers/:id",
          name: "myPatientBarriers",
          component: Barriers
        },
        { path: "actions/:id", name: "myPatientActions", component: Actions },
        {
          path: "conversas_encerradas/:id",
          name: "myPatientChatHistory",
          component: ChatHistory
        },
        {
          path: "anexos/:id",
          name: "myPatientAttachments",
          component: AttachedDocuments
        },
        {
          path: "teleconsultas/:id",
          name: "myPatientTeleconsultas",
          component: VideoCallHistory
        },
        {
          path: "gestao/:id",
          name: "myPatientManagement",
          component: PatientManagement,
          meta: { minRole: 1 }
        }
      ]
    },
    {
      path: "/pacientes/cadastrar/passo1",
      name: "step1PatientInformation",
      component: Step1PatientInformation,
      meta: { access_control: "add_patient" }
    },
    {
      path: "/pacientes/cadastrar/passo2/:id",
      name: "step2PatientInformation",
      component: Step2PatientInformation,
      meta: { access_control: "add_patient" }
    },
    {
      path: "/pacientes/cadastrar/passo3/:id",
      name: "step3PatientInformation",
      component: Step3PatientInformation,
      meta: { access_control: "add_patient" }
    },
    {
      path: "/pacientes/cadastrar/passo4/:id",
      name: "step4PatientInformation",
      component: Step4PatientInformation,
      meta: { access_control: "add_patient" }
    },

    { path: "/acoes", name: "acoes", title: "Ações", component: AllActions },
    {
      path: "/notificacoes",
      name: "notifications",
      component: () => import("./views/notifications/Notifications.vue")
    },
    {
      path: "/comunicados",
      name: "communicated",
      title: "Comunicados",
      component: Announcements
    },
    {
      path: "/configuracoes/mensagens-automaticas",
      name: "automaticMessages",
      title: "Mensagens Automáticas",
      component: AutomaticMessages,
      meta: { feature: 15, minRole: 1 }
    },
    // {
      // path: "/configuracoes/tipos-de-registro",
      // name: "historyRecordTypes",
      // title: "Tipos de Registro",
      // component: HistoryRecordTypes
    // },
    {
      path: "/videocall/:callId",
      name: "VideoCall",
      component: () => import("@/views/videoCall/CallWindow.vue"),
      meta: { feature: 13 }
    },
    {
      path: "/agenda",
      name: "calendar",
      title: "Agenda",
      component: LilaCalendar
    },
    {
      path: "/jornada",
      name: "journey",
      title: "Jornada",
      component: Journey,
      meta: { feature: 14 }
    },
    // POC Cuidados Paliativos: ambulatório do dia, reaproveitando a tela da Jornada.
    {
      path: "/ambulatorio",
      name: "ambulatory",
      title: "Ambulatório",
      component: Journey,
      meta: { board: "ambulatorio", feature: 16 }
    },
    {
      path: "/relatorios",
      name: "reports",
      title: "Relatórios",
      component: Reports,
      meta: { minRole: 1 }
    },
    {
      path: "/rede-cp",
      name: "palliativeNetwork",
      title: "Rede de CP",
      component: PalliativeNetwork,
      meta: { minRole: 2, feature: 16 }
    },
    // Tela 8: sem "title", não entra no menu; aberta só pelo painel.
    {
      path: "/rede-cp/equipe/:id",
      name: "palliativeTeamDetail",
      component: PalliativeTeamDetail,
      meta: { minRole: 2, feature: 16 }
    },
    {
      path: "/producao-sus",
      name: "susProduction",
      title: "Produção SUS",
      component: SusProduction,
      meta: { minRole: 1, feature: 16 }
    },
    {
      path: "/profissionais",
      name: "professionals",
      title: "Profissionais",
      component: Professionals,
      meta: { minRole: 1 }
    },
    {
      path: "/profissionais/adicionar",
      name: "addProfessional",
      title: "Novo Profissional",
      component: AddProfessional,
      meta: { minRole: 1 }
    },
    {
      path: "/profissionais/editar/:id",
      name: "editProfessional",
      title: "Editar Profissional",
      component: AddProfessional,
      meta: { minRole: 1 }
    },
    {
      path: "/unidades",
      name: "units",
      title: "Unidades / Equipes",
      component: Units,
      meta: { minRole: 1 }
    },
    {
      path: "/unidades/adicionar",
      name: "addUnit",
      title: "Nova Unidade / Equipe",
      component: AddUnit,
      meta: { minRole: 1 }
    },
    {
      path: "/unidades/editar/:id",
      name: "editUnit",
      title: "Editar Unidade / Equipe",
      component: AddUnit,
      meta: { minRole: 1 }
    },
    {
      path: "/licencas",
      name: "licenses",
      title: "Licenças",
      component: Licenses,
      meta: { minRole: 1 }
    },
    {
      path: "/bi",
      name: "bi",
      title: "BI",
      component: BI,
      meta: { feature: 5, minRole: 1 }
    },
    { path: "/", name: "userName", title: "", action: "userName" },
    {
      path: "/",
      name: "dropDownMenu",
      title: "",
      action: "submenu",
      component: SubmenuPerfil,
      children: [
        {
          path: "dados_cadastrais",
          name: "registrationData",
          title: "Dados Cadastrais",
          component: Perfil
        },
        {
          path: "alterar_senha",
          name: "changePassword",
          title: "Alterar Senha",
          component: ChangePassword
        },
        { path: "#", name: "tutorial", title: "Tutorial" },
        {
          path: "termo_uso",
          name: "termsOfUse",
          title: "Termo de Uso",
          component: AppTerms
        },
        {
          path: "quem_somos",
          name: "whoWeAre",
          title: "Quem Somos",
          component: WhoWeAre
        },
        {
          path: "logout",
          name: "logout",
          action: "logout",
          title: "Logout",
          component: null
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (
    !app.config.globalProperties.$notRequiredAuth.includes(to.name) &&
    app.config.globalProperties.$Session.get(
      app.config.globalProperties.$userSessionName
    ) == false
  ) {
    next({ name: "login" });
  } else if (
    app.config.globalProperties.$notRequiredAuth.includes(to.name) &&
    !to.meta.alwaysPublic &&
    app.config.globalProperties.$Session.get(
      app.config.globalProperties.$userSessionName
    ) != false
  ) {
    next({ name: "patientTickets" });
  } else {
    if (typeof to.meta.access_control != "undefined") {
      if (
        app.config.globalProperties.$AccessControl.cannot(
          app.config.globalProperties.$Session.get(
            app.config.globalProperties.$userSessionName
          ).profile,
          to.meta.access_control
        )
      ) {
        next({ name: "myPatients" });
        return;
      }
    }

    if (typeof to.meta.feature != "undefined") {
      const session = app.config.globalProperties.$Session.get(
        app.config.globalProperties.$userSessionName
      );
      if (session) {
        const decoded = decodeToken(session.token.Value);
        if (!decoded || !decoded.FeaturesId.includes(to.meta.feature)) {
          next({ name: "patientTickets" });
          return;
        }
      }
    }

    if (typeof to.meta.minRole != "undefined") {
      const session = app.config.globalProperties.$Session.get(
        app.config.globalProperties.$userSessionName
      );
      if (session) {
        const decoded = decodeToken(session.token.Value);
        const role = decoded ? Number(decoded.ProfessionalRole ?? 0) : 0;
        if (role < to.meta.minRole) {
          next({ name: "patientTickets" });
          return;
        }
      }
    }

    next();
  }
});

export default router;
